import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { ISalariesStatisticsResponse } from "../domain/ISalariesStatisticsResponse";
import { IYearRequestParams } from "../domain/IYearRequestParams";
import { StatisticsService } from "../services/statistics.service";

interface SalariesStatisticsState {
  loading: boolean;
  statistics?: ISalariesStatisticsResponse;
  error: any;
}

const initialState: SalariesStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getSalariesStatistics = createAsyncThunk(
  "Statistics/getSalariesStatistics",
  async (year?: IYearRequestParams) => {
    try {
      const result = await StatisticsService.getSalariesStatistics(year);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const SalariesStatisticsSlice = createSlice({
  name: "SalariesStatistics",
  initialState: initialState,
  reducers: {
    setStatistics: (
      state,
      action: PayloadAction<ISalariesStatisticsResponse>
    ) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSalariesStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSalariesStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.statistics = action.payload ? action.payload : undefined;
    });
    builder.addCase(getSalariesStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.statistics.salaries;

export const { setError } = SalariesStatisticsSlice.actions;

export default SalariesStatisticsSlice.reducer;


